import React from "react";

// Elegant serif wordmark with oxblood dot accent, inline SVG for crispness
export const RariumWordmark = ({ className = "", inverted = false }) => {
  const c = inverted ? "#FAFAF9" : "#1C1917";
  return (
    <svg
      viewBox="0 0 240 80"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      role="img"
      aria-label="Rarium"
    >
      <text
        x="0"
        y="58"
        fontFamily="'Cormorant Garamond', Georgia, serif"
        fontWeight="500"
        fontSize="64"
        letterSpacing="-1.4"
        fill={c}
      >Rarium</text>
      <circle cx="212" cy="52" r="6" fill="#8C3A3A" />
    </svg>
  );
};

export const RariumMark = ({ className = "" }) => (
  <svg
    viewBox="0 0 60 60"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    role="img"
    aria-label="Rarium"
  >
    <rect x="1" y="1" width="58" height="58" fill="none" stroke="#1C1917" strokeWidth="1.5"/>
    <text
      x="30"
      y="43"
      textAnchor="middle"
      fontFamily="'Cormorant Garamond', Georgia, serif"
      fontWeight="600"
      fontSize="40"
      fill="#1C1917"
    >R</text>
    <circle cx="42" cy="45" r="3" fill="#8C3A3A"/>
  </svg>
);

export default RariumWordmark;
